import React from 'react';
import PropTypes from 'prop-types';

export const PhoneLink = ({ children }) => (
  <a href={`tel:${children[0].replace(/ /g, '')}`}>{children}</a>
);

PhoneLink.propTypes = {
  children: PropTypes.arrayOf(PropTypes.string),
};

PhoneLink.defaultProps = {
  children: [],
};
